export default "* Knob\n* Råbåndsknob\n* Binde/surre";